import { getBearerToken } from './auth-token';
import { getPlayerToken } from './player-identity-service';

export const getAuthHeaders = async (playerId: string): Promise<Record<string, string>> => {
    const bearer = await getBearerToken();
    if (bearer) return { Authorization: `Bearer ${bearer}` };

    const token = getPlayerToken(playerId);
    return token ? { 'X-Player-Id': playerId, 'X-User-Token': token } : {};
};
